import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { StudentCheckTestService } from './student-check-test.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IncorrectlyAnsweredQuestionsResolver implements Resolve<any> {


  constructor(private testService: StudentCheckTestService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    const id = route.paramMap.get('ctId');
    if (route.data.type === 'ct') {
      return this.testService.getCTIncorrectlyAnsweredQuestion(+id);
    } else {
      return this.testService.getSAIncorrectlyAnsweredQuestion(+id);
    }
  }
}


